export const sftpParserTypeEnum = {
  kamstrup_ready: 'kamstrup_ready',
} as const

export type SftpParserTypeEnum = (typeof sftpParserTypeEnum)[keyof typeof sftpParserTypeEnum]

/**
 * @description Parser types for SFTP receiver integration.
 */
export type SftpParserType = SftpParserTypeEnum